import type { Vehicle } from '../types/vehicle'

const IMG = {
  pickupWhite:
    'https://cdn.magicpatterns.com/patterns/generated-images/57018f00-9e0a-4d86-a838-dc5406a360e3.jpg',
  pickupBlack:
    'https://cdn.magicpatterns.com/patterns/generated-images/757e6a14-9f98-47ab-8f5b-bf1abeda9d01.jpg',
  sedanGrey:
    'https://cdn.magicpatterns.com/patterns/generated-images/9b9dbdca-e6f8-4a24-842e-bfd95e067111.jpg',
  sedanBlack:
    'https://cdn.magicpatterns.com/patterns/generated-images/e586bf59-c0a6-4921-b464-c375e5eaddf5.jpg',
  suvBlue:
    'https://cdn.magicpatterns.com/patterns/generated-images/486ee7d7-f653-4a9f-a323-3939556e4603.jpg',
  suvWhite:
    'https://cdn.magicpatterns.com/patterns/generated-images/7237270d-9657-467d-ac21-8323ee99482b.jpg',
  hatchRed:
    'https://cdn.magicpatterns.com/patterns/generated-images/e8b07fc9-6806-4f85-89a6-d078bf9fa22f.jpg',
  sportSilver:
    'https://cdn.magicpatterns.com/patterns/generated-images/f991709d-4022-4358-9961-f33ba76608ce.jpg',
}

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/0f72f68e-d3df-4887-90dc-909c2626b280.jpg'

export const SELL_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/cbed6401-6959-41f4-9a90-240ff4789d19.jpg'

export const WA_VENDEDOR = '5491156449518'

export const vehicles: Vehicle[] = [
  {
    id: 'VC-001',
    slug: 'toyota-hilux-srx-4x4-2022',
    marca: 'Toyota',
    modelo: 'Hilux',
    version: 'SRX 2.8 TDI 4x4 AT',
    anio: 2022,
    kilometraje: 48000,
    precio: 46900,
    moneda: 'USD',
    tipo: 'Pick-up',
    estado: 'Usado',
    combustible: 'Diesel',
    transmision: 'Automática',
    color: 'Blanco Perlado',
    ubicacion: 'Rosario, Santa Fe',
    descripcionCorta:
      'Unidad impecable, service oficial al día y único dueño.',
    descripcionCompleta:
      'Hilux SRX 4x4 automática con service oficial completo, cubiertas nuevas, cobertor de caja y barra antivuelco. Unidad de único dueño, revisada punto por punto por nuestro taller antes de la publicación. Título y verificación policial al día, lista para transferir.',
    imagenPrincipal: IMG.pickupWhite,
    galeria: [IMG.pickupWhite, IMG.pickupBlack, IMG.suvBlue],
    disponible: true,
    destacado: true,
    oportunidad: false,
    financiacion: true,
    permuta: true,
    whatsapp: WA_VENDEDOR,
    vendedor: 'Martín Vega',
    fechaPublicacion: '2026-08-18',
  },
  {
    id: 'VC-002',
    slug: 'volkswagen-amarok-highline-2021',
    marca: 'Volkswagen',
    modelo: 'Amarok',
    version: 'Highline 3.0 V6 4Motion',
    anio: 2021,
    kilometraje: 72500,
    precio: 44500,
    moneda: 'USD',
    tipo: 'Pick-up',
    estado: 'Usado',
    combustible: 'Diesel',
    transmision: 'Automática',
    color: 'Negro Deep',
    ubicacion: 'Rosario, Santa Fe',
    descripcionCorta: 'V6 258cv, full full, con permuta y financiación.',
    descripcionCompleta:
      'Amarok V6 Highline con interior en cuero, techo corredizo, cámara de retroceso y llantas originales de 19". Mantenimiento realizado en concesionario oficial. Aceptamos permuta por vehículo de menor valor y financiamos hasta el 50%.',
    imagenPrincipal: IMG.pickupBlack,
    galeria: [IMG.pickupBlack, IMG.pickupWhite, IMG.sedanBlack],
    disponible: true,
    destacado: true,
    oportunidad: true,
    financiacion: true,
    permuta: true,
    whatsapp: WA_VENDEDOR,
    vendedor: 'Martín Vega',
    fechaPublicacion: '2026-08-20',
  },
  {
    id: 'VC-003',
    slug: 'toyota-corolla-xei-cvt-2021',
    marca: 'Toyota',
    modelo: 'Corolla',
    version: 'XEI 2.0 CVT',
    anio: 2021,
    kilometraje: 55300,
    precio: 24900,
    moneda: 'USD',
    tipo: 'Sedán',
    estado: 'Usado',
    combustible: 'Nafta',
    transmision: 'Automática',
    color: 'Gris Grafito',
    ubicacion: 'Rosario, Santa Fe',
    descripcionCorta:
      'Sedán ideal para uso familiar, muy bajo consumo y service al día.',
    descripcionCompleta:
      'Corolla XEI CVT con pantalla multimedia, control de crucero, sensores de estacionamiento y asistencias Toyota Safety Sense. Unidad de particular seleccionada, sin detalles de chapa ni pintura.',
    imagenPrincipal: IMG.sedanGrey,
    galeria: [IMG.sedanGrey, IMG.sedanBlack, IMG.hatchRed],
    disponible: true,
    destacado: false,
    oportunidad: false,
    financiacion: true,
    permuta: true,
    whatsapp: WA_VENDEDOR,
    vendedor: 'Lucía Ferrari',
    fechaPublicacion: '2026-08-12',
  },
  {
    id: 'VC-004',
    slug: 'ford-ranger-limited-2023',
    marca: 'Ford',
    modelo: 'Ranger',
    version: 'Limited 3.0 V6 4x4 AT',
    anio: 2023,
    kilometraje: 0,
    precio: 62900,
    moneda: 'USD',
    tipo: 'Pick-up',
    estado: '0KM',
    combustible: 'Diesel',
    transmision: 'Automática',
    color: 'Azul Lightning',
    ubicacion: 'Entrega en Rosario',
    descripcionCorta: '0KM con entrega inmediata y planes de financiación.',
    descripcionCompleta:
      'Nueva Ranger Limited V6 0KM, con garantía oficial de fábrica y entrega inmediata. Consultá planes de financiación en cuotas, tasa subsidiada y toma de tu usado como parte de pago.',
    imagenPrincipal: IMG.suvBlue,
    galeria: [IMG.suvBlue, IMG.pickupBlack, IMG.suvWhite],
    disponible: true,
    destacado: true,
    oportunidad: false,
    financiacion: true,
    permuta: true,
    whatsapp: WA_VENDEDOR,
    vendedor: 'Martín Vega',
    fechaPublicacion: '2026-08-22',
  },
  {
    id: 'VC-005',
    slug: 'volkswagen-taos-comfortline-2022',
    marca: 'Volkswagen',
    modelo: 'Taos',
    version: 'Comfortline 250 TSI',
    anio: 2022,
    kilometraje: 39800,
    precio: 31500,
    moneda: 'USD',
    tipo: 'SUV',
    estado: 'Usado',
    combustible: 'Nafta',
    transmision: 'Automática',
    color: 'Azul Noche',
    ubicacion: 'Rosario, Santa Fe',
    descripcionCorta: 'SUV compacta full, con garantía extendida disponible.',
    descripcionCompleta:
      'Taos Comfortline con caja automática de 6 velocidades, climatizador bizona, sensores de lluvia y luz, y pantalla App Connect. Recibimos usado en parte de pago y ofrecemos garantía extendida opcional.',
    imagenPrincipal: IMG.suvBlue,
    galeria: [IMG.suvBlue, IMG.suvWhite, IMG.sedanGrey],
    disponible: true,
    destacado: false,
    oportunidad: true,
    financiacion: true,
    permuta: true,
    whatsapp: WA_VENDEDOR,
    vendedor: 'Lucía Ferrari',
    fechaPublicacion: '2026-08-15',
  },
  {
    id: 'VC-006',
    slug: 'ford-ecosport-titanium-2019',
    marca: 'Ford',
    modelo: 'EcoSport',
    version: 'Titanium 1.5 AT',
    anio: 2019,
    kilometraje: 88400,
    precio: 17900,
    moneda: 'USD',
    tipo: 'SUV',
    estado: 'Usado',
    combustible: 'Nafta',
    transmision: 'Automática',
    color: 'Blanco Oxford',
    ubicacion: 'Funes, Santa Fe',
    descripcionCorta: 'Oportunidad del mes con financiación en cuotas fijas.',
    descripcionCompleta:
      'EcoSport Titanium automática con cuero, techo, cámara y sensores. Unidad revisada, con detalles mínimos de uso informados en la ficha técnica. Excelente oportunidad para primer auto o uso urbano.',
    imagenPrincipal: IMG.suvWhite,
    galeria: [IMG.suvWhite, IMG.suvBlue, IMG.hatchRed],
    disponible: true,
    destacado: false,
    oportunidad: true,
    financiacion: true,
    permuta: false,
    whatsapp: WA_VENDEDOR,
    vendedor: 'Diego Sosa',
    fechaPublicacion: '2026-08-10',
  },
  {
    id: 'VC-007',
    slug: 'volkswagen-polo-highline-2023',
    marca: 'Volkswagen',
    modelo: 'Polo',
    version: 'Highline 1.6 MSI AT',
    anio: 2023,
    kilometraje: 21000,
    precio: 21400,
    moneda: 'USD',
    tipo: 'Hatchback',
    estado: 'Usado',
    combustible: 'Nafta',
    transmision: 'Automática',
    color: 'Rojo Sunset',
    ubicacion: 'Rosario, Santa Fe',
    descripcionCorta: 'Muy poco uso, aún con garantía de fábrica vigente.',
    descripcionCompleta:
      'Polo Highline automático con garantía de fábrica vigente, pantalla de 10", climatizador digital y llantas de aleación. Unidad de particular gestionada por VCARS, con historial de service verificable.',
    imagenPrincipal: IMG.hatchRed,
    galeria: [IMG.hatchRed, IMG.sedanGrey, IMG.suvWhite],
    disponible: true,
    destacado: true,
    oportunidad: false,
    financiacion: true,
    permuta: true,
    whatsapp: WA_VENDEDOR,
    vendedor: 'Lucía Ferrari',
    fechaPublicacion: '2026-08-19',
  },
  {
    id: 'VC-008',
    slug: 'toyota-corolla-cross-xei-hybrid-2024',
    marca: 'Toyota',
    modelo: 'Corolla Cross',
    version: 'XEI Hybrid eCVT',
    anio: 2024,
    kilometraje: 0,
    precio: 43800,
    moneda: 'USD',
    tipo: 'SUV',
    estado: '0KM',
    combustible: 'Híbrido',
    transmision: 'Automática',
    color: 'Blanco Perlado',
    ubicacion: 'Entrega en Rosario',
    descripcionCorta: '0KM híbrida, consumo mínimo y entrega coordinada.',
    descripcionCompleta:
      'Corolla Cross Hybrid 0KM con garantía oficial, tecnología híbrida autorecargable y consumo promedio de 4,2 L/100km. Financiación para 0KM con asesoramiento personalizado y toma de usado.',
    imagenPrincipal: IMG.suvWhite,
    galeria: [IMG.suvWhite, IMG.suvBlue, IMG.sedanGrey],
    disponible: true,
    destacado: true,
    oportunidad: false,
    financiacion: true,
    permuta: true,
    whatsapp: WA_VENDEDOR,
    vendedor: 'Martín Vega',
    fechaPublicacion: '2026-08-21',
  },
  {
    id: 'VC-009',
    slug: 'ford-focus-titanium-2018',
    marca: 'Ford',
    modelo: 'Focus',
    version: 'Titanium 2.0 AT',
    anio: 2018,
    kilometraje: 104000,
    precio: 15400,
    moneda: 'USD',
    tipo: 'Sedán',
    estado: 'Usado',
    combustible: 'Nafta',
    transmision: 'Automática',
    color: 'Negro Ébano',
    ubicacion: 'Rosario, Santa Fe',
    descripcionCorta: 'Full equipo, mecánica sana y precio conversable.',
    descripcionCompleta:
      'Focus Titanium con cuero, techo panorámico, navegador y sensores de estacionamiento. Correa de distribución realizada, embrague y frenos en excelente estado. Se acepta permuta por unidad de menor valor.',
    imagenPrincipal: IMG.sedanBlack,
    galeria: [IMG.sedanBlack, IMG.sedanGrey, IMG.hatchRed],
    disponible: true,
    destacado: false,
    oportunidad: true,
    financiacion: false,
    permuta: true,
    whatsapp: WA_VENDEDOR,
    vendedor: 'Diego Sosa',
    fechaPublicacion: '2026-08-06',
  },
  {
    id: 'VC-010',
    slug: 'toyota-etios-xls-2020',
    marca: 'Toyota',
    modelo: 'Etios',
    version: 'XLS 1.5 MT',
    anio: 2020,
    kilometraje: 67200,
    precio: 13900,
    moneda: 'USD',
    tipo: 'Hatchback',
    estado: 'Usado',
    combustible: 'Nafta',
    transmision: 'Manual',
    color: 'Gris Plata',
    ubicacion: 'Funes, Santa Fe',
    descripcionCorta: 'Ideal primer auto, bajo consumo y mantenimiento simple.',
    descripcionCompleta:
      'Etios XLS manual, unidad de particular con service oficial completo y muy buen estado general de interior. Excelente relación precio–confiabilidad para uso urbano diario.',
    imagenPrincipal: IMG.hatchRed,
    galeria: [IMG.hatchRed, IMG.sedanGrey],
    disponible: true,
    destacado: false,
    oportunidad: false,
    financiacion: true,
    permuta: true,
    whatsapp: WA_VENDEDOR,
    vendedor: 'Diego Sosa',
    fechaPublicacion: '2026-08-02',
  },
  {
    id: 'VC-011',
    slug: 'volkswagen-vento-gli-2019',
    marca: 'Volkswagen',
    modelo: 'Vento',
    version: 'GLI 2.0 TSI DSG',
    anio: 2019,
    kilometraje: 74600,
    precio: 26900,
    moneda: 'USD',
    tipo: 'Sedán',
    estado: 'Usado',
    combustible: 'Nafta',
    transmision: 'Automática',
    color: 'Gris Platino',
    ubicacion: 'Rosario, Santa Fe',
    descripcionCorta: 'Deportivo 211cv, DSG impecable y unidad original.',
    descripcionCompleta:
      'Vento GLI con caja DSG, butacas deportivas, llantas originales y unidad totalmente original de chapa y pintura. Mantenimiento en taller especializado, con historial documentado.',
    imagenPrincipal: IMG.sportSilver,
    galeria: [IMG.sportSilver, IMG.sedanBlack, IMG.sedanGrey],
    disponible: true,
    destacado: false,
    oportunidad: false,
    financiacion: true,
    permuta: true,
    whatsapp: WA_VENDEDOR,
    vendedor: 'Lucía Ferrari',
    fechaPublicacion: '2026-08-08',
  },
  {
    id: 'VC-012',
    slug: 'ford-mustang-gt-2021',
    marca: 'Ford',
    modelo: 'Mustang',
    version: 'GT 5.0 V8 AT',
    anio: 2021,
    kilometraje: 19500,
    precio: 89900,
    moneda: 'USD',
    tipo: 'Coupé',
    estado: 'Usado',
    combustible: 'Nafta',
    transmision: 'Automática',
    color: 'Gris Iridium',
    ubicacion: 'Rosario, Santa Fe',
    descripcionCorta: 'Unidad de colección, muy pocos kilómetros reales.',
    descripcionCompleta:
      'Mustang GT V8 con escape activo, butacas Recaro, sistema B&O y muy bajo kilometraje real. Unidad de colección, siempre en cochera, con documentación completa. Se escuchan ofertas y se toma permuta de alta gama.',
    imagenPrincipal: IMG.sportSilver,
    galeria: [IMG.sportSilver, IMG.sedanBlack, IMG.pickupBlack],
    disponible: true,
    destacado: true,
    oportunidad: false,
    financiacion: false,
    permuta: true,
    whatsapp: WA_VENDEDOR,
    vendedor: 'Martín Vega',
    fechaPublicacion: '2026-08-23',
  },
]

export const marcas = Array.from(new Set(vehicles.map((v) => v.marca))).sort()
export const modelos = Array.from(new Set(vehicles.map((v) => v.modelo))).sort()
export const tipos = Array.from(new Set(vehicles.map((v) => v.tipo))).sort()
export const combustibles = Array.from(
  new Set(vehicles.map((v) => v.combustible)),
).sort()
